export default __webpack_public_path__ + "static/media/previous-active.1d0c15a9.svg";